import { Injectable } from '@angular/core';
import { NetworkConstants, removeUndefinedValuesFromObject } from 'na-lib';
import { SettingsService } from './settings.service';
import { newTaskTemplate } from 'na-lib';
import { collection, deleteDoc, doc, setDoc, updateDoc, deleteField } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root'
})
export class WorkTaskTemplatesService {
  db = this.firestore.db//getFirestore()

  constructor(private settingsService: SettingsService,
    private firestore:FirestoreService) { }

  async createWorkTaskTemplateGroup(data):Promise<string>{
    return new Promise(async (resolve, reject) => {
      const docRef = doc( collection(this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_WORK_TASK_TEMPLATES) )
      const newId = docRef.id
      let newWorktt = newTaskTemplate
      newWorktt['creationDate'] = new Date()
      newWorktt['timeStamp'] = new Date()
      newWorktt['id'] = newId
      newWorktt['taskType'] = 'create'
      if(data['groupId'])
        newWorktt['groupId'] = data['groupId']
      if(data['title'])
        newWorktt['title'] = data['title']

      try{
        await setDoc( docRef, newWorktt)
        resolve(newId)
      }catch (error) {
        reject(error)
      }
    })

  }

  updateWorkTaskTemplate(workTaskTemplate:any, id:any):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try{
        const taskId = id
        workTaskTemplate.id = id
        const data = removeUndefinedValuesFromObject({ ...workTaskTemplate, id: taskId })
        data['timeStamp']= new Date()
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_WORK_TASK_TEMPLATES, taskId )
        await updateDoc( docRef, data)
        
        resolve()
      }catch(error){
        reject(error)
      }
    }) 
  }

  deleteworkTaskTemplate(workTaskTemplateId: any):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_WORK_TASK_TEMPLATES, workTaskTemplateId)
        const d  = await deleteDoc( docRef)
        resolve(d)
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }

  removeTaskFromGroup(task,contextId){
    return new Promise<void>(async (resolve, reject) => {
      try {
        task['timeStamp'] = new Date()
        task.groupId = deleteField()
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_WORK_TASK_TEMPLATES, task.id )
        await updateDoc( docRef, task)

        resolve()
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }

  updateTaskSortIndex(contextId: string, taskId: string, data: any) {

    return new Promise<void>(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, contextId,NetworkConstants.COLLECTION_WORK_TASK_TEMPLATES, taskId )
        await updateDoc( docRef, data)
        resolve()
      } catch (error) {
        reject(error)  
        console.error('Error updating sortIndex:', error);
      } 
    })
  }

}